import { styled } from '@linaria/react'

export const HighlightedMatchSpan = styled('span')`
    border-bottom: 1.5px solid #e9d201;
`

// `
//     font-weight: bold;
//     background-color: var(--status-message);
//     color: #000;
// `
